const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const ColorUtil = require("../core/util/ColorUtil");
const _ = require("lodash");
const HoverText = require("../core/view/HoverText");

const styles = require("./styles/GradeBarGraph.css");

module.exports = createReactClass({
	displayName: "GradeBarGraph",

	propTypes: {
		className: PT.string,
		gradeID: PT.number.isRequired,
		// For useVariableSizes: array of 4 numbers with sum less than 1,
		// giving bar sizes starting from 0 stars and ending at 3 stars.
		barData: PT.array.isRequired,
		backgroundColor: PT.string,
		continuous: PT.bool,
		useVariableSizes: PT.bool,
		isVertical: PT.bool,
		isSorted: PT.bool,
		handleClick: PT.func,
		hoverContent: PT.array,
	},

	getColors: function() {
		if (this.props.gradeID === 0) {
			return ColorUtil.getBlueStarColors(4);
		}

		return ColorUtil.getThemeColors("grade" + this.props.gradeID).profile;
	},

	getSectionsBySize: function(sectionBarSizes) {
		// Decreasing star-associated colors
		const colors = this.getColors();

		let subsections = [];

		if (sectionBarSizes) {
			const starColors = colors;
			const starsBarSizes = _.reverse(sectionBarSizes);

			subsections = starColors.map((color, i) => {
				const style = {
					width: starsBarSizes[i] * 100 + "%",
					backgroundColor: color,
				};
				const sectionClass = this.props.isVertical
					? styles.subsectionVert
					: styles.subsection;
				return <div className={sectionClass} key={i} style={style} />;
			});
		}

		return subsections;
	},

	getSectionsByColor: function(sectionBarColors, hoverTexts) {
		// Decreasing star-associated colors
		const colors = this.getColors();
		const {isVertical, continuous} = this.props;

		let getSectionColor;

		if (continuous) {
			const blueColors7 = ColorUtil.getBlueStarColors(7);
			getSectionColor = function(value) {
				const colorIndex = 6 - _.round(2 * value, 0);
				return blueColors7[colorIndex];
			};
		} else {
			const increasingStarColors = _.reverse(colors);

			getSectionColor = function(value) {
				return increasingStarColors[value];
			};
		}

		const subsections = [];
		let percent, bgColor;

		if (sectionBarColors) {
			const numSubsections = sectionBarColors.length;
			_.each(sectionBarColors, (colorIndex, i) => {
				bgColor = colorIndex < 0 ? "transparent" : getSectionColor(colorIndex);
				const style = {
					backgroundColor: bgColor,
				};
				const outerStyle = {};
				percent = (100 * 1) / numSubsections + "%";
				if (isVertical) {
					outerStyle.height = percent;
				} else {
					outerStyle.width = percent;
				}
				if (isVertical) {
					_.extend(outerStyle, style);
					subsections.push(
						<div className={styles.subsectionVert} key={i} style={outerStyle} />
					);
				} else {
					const text = (hoverTexts && hoverTexts[i]) || "";
					// Try to fit hover content within graph length.
					const direction = i < numSubsections / 2 ? "br" : "bl";
					subsections.push(
						<HoverText
							text={text}
							key={i}
							style={outerStyle}
							size={"medium"}
							direction={direction}
						>
							<div className={styles.subsection} style={style} />
						</HoverText>
					);
				}
			});
		}

		return subsections;
	},

	// Returns bar DOM without quad transformation.
	render: function() {
		const {isSorted, isVertical, barData, hoverContent} = this.props;
		const numSections = barData.length;
		const sections = barData.map((data, i) => {
			let dataToUse = _.clone(data);
			const hoverTexts = hoverContent && hoverContent[i];
			if (isSorted) {
				dataToUse = dataToUse.sort();
			}

			let subsections;

			if (this.props.useVariableSizes) {
				subsections = this.getSectionsBySize(dataToUse);
			} else {
				subsections = this.getSectionsByColor(dataToUse, hoverTexts);
			}

			const style = {
				width:
					(numSections === 1 ? 100 : Math.floor(900 / numSections) / 10) + "%",
				backgroundColor:
					this.props.backgroundColor ||
					ColorUtil.getCurrentScheme().disabledLightIcon,
			};

			if (isVertical) {
				delete style.width;
			}

			return (
				<div className={styles.section} style={style} key={"bar_" + i}>
					{subsections}
				</div>
			);
		});

		let fullClassName = isVertical ? styles.vert : styles.main;
		fullClassName += this.props.className ? " " + this.props.className : "";

		return (
			<div className={fullClassName} onClick={this.props.handleClick}>
				{sections}
			</div>
		);
	},
});
